/** All the possible types for a member */

/** All the possible types for the role of a member in company or project */

/** The entity type that caused a partial role change */

/**
 * Assignable company roles for members when bulk-updating the role.
 * Group Viewer is intentionally excluded because it can't be reliably bulk-applied.
 */
export const AssignableUpdateCompanyMemberRole = ["COMPANY_EXECUTIVE", "COMPANY_VIEWER", "MEMBER"];

// TODO: ST-646 Should be removed at the end of ST-646 */
/** A workaround to make it easy to extend the usage of SdbMember */

// TODO: ST-646 Should be removed at the end of ST-646 */
/** A workaround to make it easy to extend the usage of SdbMember */

/** Combination of member and team */

/** Base props for member */

/** Base props for member */

/** Base props for a user covering isLoggedInUser. In here user is defined as the person working on our app */

// TODO: ST-646 Do we really need this as it is only used in one place

/** A type that holds the identity and the role of a member or team */

/**
 * Ordering represents organization hierarchy
 * Please don't change the order of the roles
 */
/* eslint-disable @typescript-eslint/naming-convention */
export let UserRoleEnum = /*#__PURE__*/function (UserRoleEnum) {
  UserRoleEnum[UserRoleEnum["MEMBER"] = 0] = "MEMBER";
  UserRoleEnum[UserRoleEnum["RESOURCE_VIEWER"] = 1] = "RESOURCE_VIEWER";
  UserRoleEnum[UserRoleEnum["RESOURCE_EDITOR"] = 2] = "RESOURCE_EDITOR";
  UserRoleEnum[UserRoleEnum["RESOURCE_ADMIN"] = 3] = "RESOURCE_ADMIN";
  UserRoleEnum[UserRoleEnum["RESOURCE_OWNER"] = 4] = "RESOURCE_OWNER";
  UserRoleEnum[UserRoleEnum["GROUP_VIEWER"] = 5] = "GROUP_VIEWER";
  UserRoleEnum[UserRoleEnum["COMPANY_VIEWER"] = 6] = "COMPANY_VIEWER";
  UserRoleEnum[UserRoleEnum["PROJECT_MANAGER"] = 7] = "PROJECT_MANAGER";
  UserRoleEnum[UserRoleEnum["COMPANY_MANAGER"] = 8] = "COMPANY_MANAGER";
  UserRoleEnum[UserRoleEnum["COMPANY_EXECUTIVE"] = 9] = "COMPANY_EXECUTIVE";
  return UserRoleEnum;
}({});
/* eslint-enable @typescript-eslint/naming-convention */

/**
 * This type covers all member types returned from different routes
 * The purpose of it is to remove the confusion between all these types
 * It is currently covering the following types:
 * ICompanyMemberBase, CompanyMemberDetails, IProjectMemberBase, IGroupMember, IUserAsManager & SdbTeamMemberBase
 * But it is not covering UserDetails yet
 */

/** Sortable column fields for the members table */
export const MEMBERS_SORT_BY = ["user_ascending", "user_descending", "name_ascending", "name_descending", "email_ascending", "email_descending", "status_ascending", "status_descending", "role_ascending", "role_descending", "joinedDate_ascending", "joinedDate_descending", "seats_ascending", "seats_descending"];

/** All possible members sort by values */